import { onBeforeMount, onBeforeUnmount, ref } from '@vue/composition-api';
import { notification } from 'ant-design-vue';
export const useNetwork = () => {
    /**
     * 断网回调
     * @author  Jerry <superzcj_001@163.com>
     * @since   2020-09-10 09:58:11
     */
    const offlineCallback = () => {
        notification.warning({
            message: '当前网络不可用',
            description: '',
            duration: 0,
        });
    };
    /**
     * 联网回调
     * @author  Jerry <superzcj_001@163.com>
     * @since   2020-09-10 09:58:19
     */
    const onlineCallback = () => {
        notification.destroy();
        notification.info({
            message: '网络已经恢复',
            description: '',
            duration: 3,
        });
    };
    // * 移除断网联网事件监听
    onBeforeUnmount(() => {
        window.removeEventListener('offline', offlineCallback);
        window.removeEventListener('online', onlineCallback);
    });
    // * 初始化断网联网事件监听
    onBeforeMount(() => {
        window.addEventListener('offline', offlineCallback);
        window.addEventListener('online', onlineCallback);
    });
};
// 更新检查间隔时间
const versionCheckTime = 1000 * 300;
export const useVersion = () => {
    const appVersionHash = ref(process.env.VERSION_HASH ?? '');
    /**
     * 检查版本
     * @author  Jerry <superzcj_001@163.com>
     * @since   2020-09-08 14:13:32
     */
    const versionCheck = async () => {
        const localHash = localStorage.getItem('version_hash');
        const hash = await fetch(`/version.txt?t=${Date.now()}`)
            .then(res => res.text())
            .then(hash => (hash.length > 32 ? '' : hash));
        if (localHash === null) {
            // 本地存储没有该值
            // 视作第一次进入版本检查逻辑
            // 初始化，不做版本判断
            appVersionHash.value = hash;
            localStorage.setItem('version_hash', hash);
        }
        else if (hash === localHash || hash === appVersionHash.value) {
            // 版本一致
            // 弱检查，只要跟代码或本地存储其中一个一致即判定一致
            // ⚠️ 不做三者两两相等的强检查的原因 ⚠️
            // 减少判定不一致情况下发起系统通知对用户的侵扰
            // 换句话说，提示过一次之后，哪怕下次载入的代码版本是缓存的旧版本也不提醒
            // 除非再次有更新版本上线
        }
        else {
            // 三个版本两两不匹配时以服务端为准
            // 写入本地存储
            localStorage.setItem('version_hash', hash);
            // 写入组件内
            // 组件内值的更新会随着页面(组件)销毁失效
            // 下次进入还是代码内初始的值，可能跟本地存储不一致
            appVersionHash.value = hash;
            await new Promise(resolve => {
                notification.info({
                    message: '更新通知',
                    description: '检查到折一管理系统有新版本更新，请刷新页面',
                    duration: 0,
                    onClose: () => {
                        resolve(undefined);
                    },
                });
            });
        }
        window.setTimeout(() => {
            versionCheck();
        }, versionCheckTime);
    };
    // 非开发环境开启定期查询版本更新
    // 开发环境不检查
    if (process.env.NODE_ENV !== 'development') {
        versionCheck();
    }
    return { appVersionHash };
};
//# sourceMappingURL=app.global.js.map
